﻿$.fn.dxCtrlBuilderEmailStyleBordureStyle = function custom_dxCtrlBuilderEmailStyleBordureStyle(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-dxctrlbuilderemailstylebordurestyle dx-ctrl");
        this.createInstance(new cdxCtrlBuilderEmailStyleBordureStyle(this, option));
    }
    return this;
}

window.cdxCtrlBuilderEmailStyleBordureStyle = function (container, option) {
    var Me = this;

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
        }
    }

    function mConstruit() {
        container.empty()

        var val = option.value
        var typeBordure = ((val == "dashed") ? "tiret" :
            ((val == "dotted") ? "Point" :
                ((val == "double") ? "Double" :
                    ((val == "groove") ? "Gravé" :
                        ((val == "inset") ? "3Din" :
                            ((val == "outset") ? "3Dout" :
                                ((val == "ridge") ? "3D" :
                                    ((val == "solid") ? "Plein" :
                                        ((val == "none") ? "Aucun" : "")))))))))
        var dsType = ["", "Aucun", "Tiret", "Point", "Double", "Gravé", "3Din", "3Dout", "3D", "Plein"]
        var dxCtrlSelectType = $("<div/>").appendTo(container).dxCtrlSelectBox({
            labelMode: "floating",
            label: "Type de bordure",
            dataSource: dsType,
            value: typeBordure,
            layout: 'horizontal',
            buttons: [{
                focusStateEnabled: false,
                name: 'pre',
                location: 'before',
                options: {
                    icon: 'spinprev',
                    stylingMode: 'text',
                    onClick() {
                        if (dsType.indexOf(dxCtrlSelectType.option("value")) > 0) {
                            dxCtrlSelectType.option("value", dsType[dsType.indexOf(dxCtrlSelectType.option("value")) - 1])
                        }
                    },
                },
            }, {
                focusStateEnabled: false,
                name: 'next',
                location: 'after',
                options: {
                    icon: 'spinnext',
                    stylingMode: 'text',
                    onClick() {
                        if (dsType.indexOf(dxCtrlSelectType.option("value")) < dsType.length - 1) {
                            dxCtrlSelectType.option("value", dsType[dsType.indexOf(dxCtrlSelectType.option("value")) + 1])
                        }
                    },
                },
            }],
            onValueChanged: function (e) {
                var newValue = ""
                switch (e.value) {
                    case "Tiret": newValue = "dashed"; break;
                    case "Point": newValue = "dotted"; break;
                    case "Double": newValue = "double"; break;
                    case "Gravé": newValue = "groove"; break;
                    case "3Din": newValue = "inset"; break;
                    case "3Dout": newValue = "outset"; break;
                    case "3D": newValue = "ridge"; break;
                    case "Plein": newValue = "solid"; break;
                    case "Aucun": newValue = "none"; break;
                    case "": newValue = ""; break;
                }
                option.onValueChanged({ values: [{ prop: "border-style", value: newValue, oldValue: option.value }] })
                option.value = newValue
            }
        }).dxCtrlSelectBox("instance")
    }

    this.element = function () { return container }

    mConstruit();
}